import BaseApiRepository from "../../../../repositories/api/BaseApiRepository";
import LocationIdbRepository from "../../../../repositories/idb/LocationIdbRepository";
import { wrapMethodsWithLogging } from "../../../helpers/ErrorHandlingHelpers";

export class MapApiRepository {

    static async searchPcsAsync(searchParameter: any) {
        const response = await BaseApiRepository.postAsync('pcs/search', searchParameter);
        return response as Response;
    }

    static async getPcsGroupAsync(id:number) {
        const response = await BaseApiRepository.getAsync(`pcs/group/${id}`);
        return response as Response;
    }

    static async searchPcsByAreaAsync(obj:any) {
        const response = await BaseApiRepository.postAsync('pcs/search/by-area', obj);
        return response as Response;
    }

    static async getEvaluationFairwayAreasAsync(obj: any) {
        const response = await BaseApiRepository.getAsync(`eval/fairway-areas?${obj}`);
        return response as Response;
    }

    static async getQuayManualByLocationAndProximity(locationId: number) {
        const response = await BaseApiRepository.getAsync(`quaymanuals/locations/${locationId}/proximity`);
        return response as Response;
    }

    static async getShipPositionsAsync(shipIds: number[], abortSignal?: AbortSignal) {
        const response = await BaseApiRepository.postAsync('source/ship-position', shipIds, abortSignal);
        return response as Response;
    }

    static async getShipPositionsWithinAreaAsync(latitude: number, longitude: number, width: number, height: number, abortSignal?: AbortSignal) {
        const response = await BaseApiRepository.getAsync(`source/ship-position/area?latitude=${latitude}&longitude=${longitude}&width=${width}&height=${height}`, abortSignal);
        return response as Response;
    }

    static async getShipPositionsByNameAsync(name: string, abortSignal?: AbortSignal) {
        const response = await BaseApiRepository.getAsync(`source/ship-position/name?name=${name}`, abortSignal);
        return response as Response;
    }

    static async getShipPositionsByMmsiAsync(mmsi: number, abortSignal?:AbortSignal) {
        const response = await BaseApiRepository.getAsync(`source/ship-position/mmsi?mmsi=${mmsi}`, abortSignal);
        return response as Response;
    }

    static async searchLocationsAsync(searchText: string) {
        const locations = await LocationIdbRepository.searchAsync(searchText);
        return locations as any[];
    }

    static async getLocationByIdAsync(id: number) {
        const location = await LocationIdbRepository.getByIdAsync(id);
        return location as any;
    }

    static async getReadOnlyPilotageByIdAsync(id: number) {
        const response = await BaseApiRepository.getAsync(`pilot/pilotage/${id}/read-only`);
        return response as Response;
    }

    static async getPecFairwayAreasAsync(id: number, pilotagePecExamId: number) {
        const response = await BaseApiRepository.getAsync(`pec-admin/pec/${id}/fairway-areas/${pilotagePecExamId}`);
        return response as Response;
    }

    static async searchPecFairwayAreasAsync(id: number, query:any) {
        const response = await BaseApiRepository.postAsync(`pec-admin/pec/${id}/fairway-areas/search`, query);
        return response as Response;
    }

    static async searchPecApplicationFairwayAreasAsync(id: number, query: any) {
        const response = await BaseApiRepository.postAsync(`pec-admin/pec-application/${id}/fairway-areas/search`, query);
        return response as Response;
    }

    static async getPilotCertificateCoastalSegmentGroupsByIdAsync(id: number) {
        const response = await BaseApiRepository.getAsync(`map/pilot/${id}/certificate/coastal-segment-groups`);
        return response as Response;
    }

    static async savePilotCertificateCoastalSegmentGroupsByIdAsync(id: number, coastalSegmentGroupIds: number[]) {
        const response = await BaseApiRepository.postAsync(`map/pilot/${id}/certificate/coastal-segment-groups`, coastalSegmentGroupIds);
        return response as Response;
    }

    static async getPilotCertificateCoastalSegmentGroupsAsync() {
        const response = await BaseApiRepository.getAsync(`map/pilot/certificate/coastal-segment-groups`);
        return response as Response;
    }

    static async savePilotCertificateCoastalSegmentGroupsAsync(coastalSegmentGroupIds: number[]) {
        const response = await BaseApiRepository.postAsync(`map/pilot/certificate/coastal-segment-groups`, coastalSegmentGroupIds);
        return response as Response;
    }

    static async searchPilotCoastalSegmentGroupsGeometriesAsync() {
        return await BaseApiRepository.postAsync('pcs/groups/geometries/search', { groupIds: [] });
    }
}

wrapMethodsWithLogging(MapApiRepository);

export default MapApiRepository;
